import { useState } from 'react';
import { MdArrowDropDown } from 'react-icons/md';
import { MdCheck } from 'react-icons/md'; // Use checkmark for right sign

function LogLevelDropdown({ value, onChange, options }) {
  const [open, setOpen] = useState(false);
  const selected = options.find(opt => opt.value === value);

  return (
    <div className="relative w-36">
      <button
        type="button"
        className="w-full flex justify-between items-center px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        style={{ color: selected?.color || '#000' }}
        onClick={() => setOpen(v => !v)}
      >
        {selected?.label}
        <MdArrowDropDown className="text-xl text-gray-400" />
      </button>
      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg">
          {options.map(opt => {
            const isSelected = opt.value === value;
            return (
              <div
                key={opt.value}
                className={`flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100 rounded ${
                  isSelected ? 'bg-blue-500 text-white' : ''
                }`}
                style={{ color: isSelected ? '#fff' : opt.color }}
                onClick={() => { onChange(opt.value); setOpen(false); }}
              >
                {/* Left side: right sign if selected */}
                {isSelected ? (
                  <MdCheck className="mr-2 text-lg" />
                ) : (
                  <span className="mr-2 w-5" /> // keep spacing
                )}
                <span className="flex-1">{opt.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LogLevelDropdown;